import { type IndustrialPremisesQueue } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { industrialPremisesQueueFilters } from '@/app/settings/modules/market/queues/industrial-premises-queues/filters';

export const IndustrialPremisesQueueItem: RelationFieldProps<IndustrialPremisesQueue> =
  {
    filters: industrialPremisesQueueFilters,
    renderItem: (item) => ({
      title: item?.name ?? '',
      descriptionItems: <></>,
    }),
  };
